import React, { useState } from "react";

import loadIcon from "../../../assets/images/tail-spin.svg";

import ModalHolder from "../../molecules/ModalHolder";

import { toastWarning } from "../../../shared/helpers";
// import { CheckBox, DarkFormField } from "../../atoms/Inputs";
import { H3, H5, P } from "../../atoms/Texts";
import { Badge, PrimaryButton } from "../../atoms/Buttons";
import { useParams } from "react-router";

const RejectReferralModal = ({ closeModal, referral }) => {
  const { user, from, serviceName } = referral;
  const { id } = useParams();

  const [badgeColor, setBadgeColor] = useState({});

  React.useEffect(() => {
    switch (true) {
      case from === "form":
        setBadgeColor({
          bgColor: "#FDD2DC",
          textColor: "#7C033C",
        });
        break;

      case from === "sdep":
        setBadgeColor({
          bgColor: "#D8FDEC",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeColor({
          bgColor: "#DCD6FE",
          textColor: "#2220A9",
        });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onacceptOrRejectReferral = () => {
    toastWarning("Can not perform this action on Demo mode");
  };

  return (
    <ModalHolder closeModal={closeModal}>
      <div className="pb-12">
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Reject Case
        </H3>
        <P color="#C92159" className="text-center md:w-3/4 mx-auto mt-2 mb-12">
          You are rejecting this case and this cannot be undone!
        </P>

        <div className="my-6 flex items-center gap-x-2 justify-between">
          <div className="flex items-center gap-x-4">
            <div
              className=" w-16 h-16 flex  items-center justify-center rounded-lg mb-3"
              style={{ background: "#EAE7FE" }}
            >
              <H5 color="#12046D" className="capitalize profile-dropdown-child">
                {`${user?.firstName?.[0]} ${user?.lastName?.[0]}`}
              </H5>
            </div>

            <div>
              <H5
                color="#716E8B"
                fontSize="16px"
                smallSize="16px"
                className=" font-semibold "
              >
                {`${referral?.user?.firstName} ${referral?.user?.lastName}`}
              </H5>
              <P
                color="#716E8B"
                fontSize="13px"
                smallSize="13px"
                className="my-0 text-center"
              >
                {user?.email}
              </P>
            </div>
          </div>

          <div className="">
            <Badge
              fontFamily="medium"
              bg={badgeColor.bgColor}
              color={badgeColor.textColor}
              className="uppercase"
              fontSize="12px"
            >
              {from}
            </Badge>
          </div>
        </div>

        <div className="flex gap-x-4">
          <PrimaryButton.Light type="button" onClick={closeModal} className="w-1/2">
            Cancel
          </PrimaryButton.Light>
          <PrimaryButton
            className="w-full reject-now"
            onClick={() => onacceptOrRejectReferral("rejected")}
          >
            Reject
          </PrimaryButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default RejectReferralModal;
